import { render, staticRenderFns } from "./CardField.vue?vue&type=template&id=16a82ff6&scoped=true&"
import script from "./CardField.vue?vue&type=script&lang=js&"
export * from "./CardField.vue?vue&type=script&lang=js&"
import style0 from "./CardField.vue?vue&type=style&index=0&id=16a82ff6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a82ff6",
  null
  
)

export default component.exports